import { useEffect } from 'react';
import { useMapStore } from '@/stores/mapStore';
import { useMapLayerConfigs } from '@/hooks/api/useMapLayers';
import { isEqual } from 'lodash';

export const useInitialMapLayers = () => {
  const addLayer = useMapStore((state) => state.addLayer);
  const updateLayer = useMapStore((state) => state.updateLayer);
  const currentLayers = useMapStore((state) => state.layers);

  const { data: layers, isLoading, error } = useMapLayerConfigs();

  useEffect(() => {
    if (!layers || layers.length === 0) return;

    layers.forEach((config: any) => {
      const existingLayer = currentLayers.find((l) => l.id === config.id);

      if (!existingLayer) {
        addLayer(config);
      } else {
        const nextLayerState = {
          ...config,
          isVisible: existingLayer.isVisible,
        };

        if (!isEqual(existingLayer, nextLayerState)) {
          updateLayer(config.id, nextLayerState);
        }
      }
    });
  }, [layers, addLayer, updateLayer, currentLayers]);

  return { isLoading, error };
};
